import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { getAutomation } from '../../../apis/approvalRules/approvalRules';
import { getVideoVoResults } from '../../../apis/videoVo/videoVo';
import { setAutomationData } from '../../../redux/reducers/automationSlice';
import { mergeVideoVoComments } from '../utils/videoVoVariables';

const getVideoVoRules = async (nid: string, country: string) => {
  try {
    const videoVo = await getVideoVoResults({ nid, country });
    return videoVo?.data?.['variables-approbology']?.[country];
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return undefined;
    }
    console.error('Error en getVideoVoRules:', error);
    return undefined;
  }
};

export const useAutomation = () => {
  const dispatch = useDispatch();
  const search = useSelector((state: any) => state.searchStore.search);

  const handleGetAutomation = async () => {
    const country = localStorage.getItem('country') || '';
    try {
      const response = await getAutomation({ nid: search, country });
      if (response?.data) {
        // video_vo es complementario: si falla, se muestra la automatización
        // sin sus comentarios en vez de perder el desplegable completo.
        const videoVoRules = await getVideoVoRules(search, country);

        dispatch(
          setAutomationData({
            summary: response.data.summary,
            variables: mergeVideoVoComments(
              response.data.variables || [],
              videoVoRules,
              country
            ),
          })
        );
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response?.status === 404) {
        return;
      }
      console.error('Error en handleGetAutomation:', error);
    }
  };

  return { handleGetAutomation };
};
